<template>
  <base-section id="ajuste-difusor">
    <base-section-heading title="Ajuste del Difusor">
      Esta operación es esencial para conseguir un lavado óptimo. La clave es apuntar la cortina de agua hacia la tangente del rodillo.
    </base-section-heading>

    <v-container>
      <v-row justify="center">
        <v-responsive
          max-width="400"
          width="100%"
        >
          <base-img
            v-bind="grafic"
          />
        </v-responsive>
      </v-row>

      <v-row>
        <v-col
          v-for="(item, i) in items"
          :key="i"
          cols="12"
          sm="4"
        >
          <base-title
            :title="item.title"
            align="center"
            class="text-uppercase"
            space="3"
          />

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-img :src="item.src[0]" />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-img :src="item.src[1]" />
            </v-col>
          </v-row>

          <base-body
            v-if="item.text"
            :space="true ? 0 : undefined"
            :text="item.text"
            class="mx-auto text-center"
            max-width="700"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAjusteDifusor',

    data: () => ({
      grafic: {
        src: require('@/assets/tangente.jpg'),
      },
      items: [
        {
          title: 'Aflojar la tuerca',
          text: 'Gira la tuerca (A) en el sentido de las agujas del reloj para aflojarla.',
          src: [
            require('@/assets/difusor/1-1.jpg'),
            require('@/assets/difusor/1-2.jpg'),
          ],
        },
        {
          title: 'Conectar',
          icon: 'mdi-numeric-2-circle-outline ',
          text: 'Ajusta el ángulo del difusor (B) girándolo hacia la posición deseada: derecha para los rodillos de mayor diámetro, e izquierda para los de menor calibre.',
          src: [
            require('@/assets/difusor/2-1.jpg'),
            require('@/assets/difusor/3-2.jpg'),
          ],
        },
        {
          title: 'Limpiar',
          icon: 'mdi-numeric-3-circle-outline ',
          text: 'Vuelve a apretar la tuerca (A) haciéndola girar en el sentido contrario al de las agujas del reloj.',
          src: [
            require('@/assets/difusor/3-1.jpg'),
            require('@/assets/difusor/3-2.jpg'),
          ],
        },
      ],
    }),
  }
</script>
